interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
}

const SelectionCheckbox = ({ checked, onChange, ariaLabel }: Props) => (
  <label className="checkbox" onClick={(e) => e.stopPropagation()}>
    <input
      type="checkbox"
      aria-label={ariaLabel}
      checked={checked}
      onChange={(e) => {
        e.stopPropagation();
        onChange(e.target.checked);
      }}
    />
    <span className="checkbox-text"></span>
  </label>
);

export default SelectionCheckbox;
